import { inject } from 'aurelia';
import { getLogger } from '../../common/logging';
import { IDialogController } from '@aurelia/dialog';
import { SignatureService } from '../../services/signature-service';
import { isGuid } from '../../b64';
import QRious from 'qrious'

@inject(IDialogController, SignatureService)
export class BankidSignDialog {
    autoStartToken = ''
    cancelled = false;
    complete = false;

    constructor(controller, SignatureService) {
        this.controller = controller;
        this.signatureService = SignatureService
    }

    attached() {
      this.afterAttached();
    }

    async afterAttached() {
        let ok = await this.sign();
        if (ok) {
            this.controller.ok();
            return;
        }
        this.cancel();
    }

    async sign() {
        const { frames, autoStartToken, orderRef } = await this.signatureService.sign(this.referenceId, this.type, this.referenceDisplay);
        this.autoStartToken = autoStartToken;
        this.orderRef = orderRef;

        this.qr = new QRious({
            element: this.canvas,
            padding: 0,
            size: 250,
            value: frames[0],
        });

        this.isPending = true;

        for (let i = 1; i < 150 && !this.cancelled; i++) {
            await this.sleep(1000);

            this.qr.set({
                value: frames[i]
            });

            if ((i + 1) % 2 == 0) {
                let x = await this.signatureService.signstatus(this.orderRef)
                this.signStatus = x;
                console.log(i, x.status, x.hintCode);

                if (this.signStatus.status != 'pending') {
                    this.isPending = false;
                    this.complete = true
                    break;
                }
            }
        }

        if (this.signStatus?.status == "complete") {
            return true;
        }

        return false;
    }

    cancel() {
        this.cancelled = true;
        this.controller.cancel();
    }

    async activate(params) {
        this.referenceId = params.referenceId;
        this.type = params.type;
        this.referenceDisplay = params.referenceDisplay;
    }

    sleep = ms => new Promise(r => setTimeout(r, ms));
}
